import { connect } from 'react-redux';

import SearchList from 'components/app-case/search-list';
import { getSearchList as getSearchListAction } from 'actions/search-list';

const mapStateToProps = (state, ownProps) => {
  const { byIds, total, status } = state.searchList;
  const { keyword } = state.caseKeyword;
  return { byIds, total, status, keyword, ...ownProps };
};

const mapDispatchToProps = dispatch => ({
  getSearchList: () => {
    dispatch(getSearchListAction());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchList);
